import type { SxProps, Theme } from '@mui/material/styles';

import { containerWidth } from '../style';

export const styles = {
    layout: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        // A light shadow is lost on the dark page
        boxShadow: (theme) => `0 0 30px 0px rgba(0,0,0,${theme.palette.mode === 'dark' ? 0.6 : 0.1})`,
        borderRadius: '8px',
        backgroundColor: 'secondary.main',
        overflow: 'hidden',
        zIndex: 1,
        width: containerWidth,
    },
    avatarSocket: {
        width: { xs: '100px', sm: '150px', md: '200px', lg: '250px', xl: '300px' },
        height: { xs: '100px', sm: '150px', md: '200px', lg: '250px', xl: '300px' },
    },
    bannerSocket: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flex: 1,
    },
    banner: {
        width: { xs: '180px', sm: '300px', md: '400px', lg: '500px', xl: '600px' },
        height: { xs: '100px', sm: '150px', md: '200px', lg: '250px', xl: '300px' },
    },
} satisfies Record<string, SxProps<Theme>>;
